Vue.component('home', {
    props: ['user'],

    mounted() {
        //
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/home.js